import { ANNUAL, HOURLY, MONTHLY } from '@/lib/constants/expenseAmountTypes'

let getExpenseAmountType = (expenseAmountTypeId) => {
  if (expenseAmountTypeId === HOURLY) {
    return '(H)'
  } else if (expenseAmountTypeId === MONTHLY) {
    return '(M)'
  } else if (expenseAmountTypeId === ANNUAL) {
    return '(A)'
  } else {
    return ''
  }
}

export default getExpenseAmountType
